import React from "react";

/* ====== Hand-drawn cartoon style retro stickers as SVGs ======
   Pure SVG, no external assets. Each renders inline so they feel like
   little scrapbook stickies you can scatter anywhere.
   Stickers (Terry Fox name/logo deliberately avoided, purely original art).
*/

const Wrap = ({ size = 96, rotate = 0, className = "", children, title }) => (
  <div
    className={`inline-block ${className}`}
    style={{ width: size, height: size, transform: `rotate(${rotate}deg)`, "--rot": `${rotate}deg` }}
    aria-label={title}
    title={title}
  >
    {children}
  </div>
);

export const StickerSun = ({ size, rotate, className }) => (
  <Wrap size={size} rotate={rotate} className={className} title="sun sticker">
    <svg viewBox="0 0 100 100" className="w-full h-full drop-shadow-[3px_3px_0_#000]">
      <g stroke="#000" strokeWidth="3" strokeLinejoin="round">
        {[...Array(8)].map((_, i) => {
          const a = (i * 45 * Math.PI) / 180;
          const x1 = 50 + Math.cos(a) * 30;
          const y1 = 50 + Math.sin(a) * 30;
          const x2 = 50 + Math.cos(a) * 45;
          const y2 = 50 + Math.sin(a) * 45;
          return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke="#F4A261" strokeWidth="6" />;
        })}
        <circle cx="50" cy="50" r="22" fill="#F4D58D" />
        <circle cx="44" cy="46" r="3" fill="#000" />
        <circle cx="56" cy="46" r="3" fill="#000" />
        <path d="M42 56 Q50 64 58 56" fill="none" stroke="#000" strokeWidth="3" strokeLinecap="round" />
      </g>
    </svg>
  </Wrap>
);

export const StickerPalm = ({ size, rotate, className }) => (
  <Wrap size={size} rotate={rotate} className={className} title="palm tree sticker">
    <svg viewBox="0 0 100 100" className="w-full h-full drop-shadow-[3px_3px_0_#000]">
      <g stroke="#000" strokeWidth="3" strokeLinejoin="round">
        <path d="M48 90 Q50 60 52 30" fill="none" stroke="#7A4A1E" strokeWidth="6" />
        <path d="M50 30 Q20 22 12 38 Q28 32 50 38 Z" fill="#7FB069" />
        <path d="M50 30 Q80 22 88 40 Q70 32 50 38 Z" fill="#7FB069" />
        <path d="M50 28 Q40 8 22 12 Q40 18 50 35 Z" fill="#27AE60" />
        <path d="M50 28 Q60 6 80 14 Q60 18 50 35 Z" fill="#27AE60" />
        <circle cx="50" cy="32" r="3" fill="#F4D58D" />
      </g>
    </svg>
  </Wrap>
);

export const StickerSurf = ({ size, rotate, className }) => (
  <Wrap size={size} rotate={rotate} className={className} title="surfer on a surfboard sticker">
    <svg viewBox="0 0 110 110" className="w-full h-full drop-shadow-[3px_3px_0_#000]">
      <g stroke="#000" strokeWidth="2.5" strokeLinejoin="round" strokeLinecap="round">
        {/* wave behind */}
        <path d="M2 92 Q22 70 44 88 Q66 104 88 86 Q100 78 108 90 L108 108 L2 108 Z" fill="#8ECAE6" />
        <path d="M10 90 Q26 80 42 88" fill="none" stroke="#fff" strokeWidth="2.5" />
        <path d="M62 88 Q78 96 96 84" fill="none" stroke="#fff" strokeWidth="2.5" />
        {/* surfboard */}
        <ellipse cx="55" cy="86" rx="36" ry="7" fill="#F4A261" transform="rotate(-8 55 86)" />
        <line x1="22" y1="84" x2="86" y2="92" stroke="#F87171" strokeWidth="2.5" />
        {/* surfer body */}
        <line x1="58" y1="84" x2="60" y2="56" stroke="#000" strokeWidth="6" strokeLinecap="round" />
        {/* legs */}
        <line x1="60" y1="56" x2="48" y2="80" stroke="#000" strokeWidth="5" strokeLinecap="round" />
        <line x1="60" y1="56" x2="70" y2="82" stroke="#000" strokeWidth="5" strokeLinecap="round" />
        {/* arms out for balance */}
        <line x1="60" y1="60" x2="40" y2="50" stroke="#000" strokeWidth="4" strokeLinecap="round" />
        <line x1="60" y1="60" x2="82" y2="48" stroke="#000" strokeWidth="4" strokeLinecap="round" />
        {/* head */}
        <circle cx="60" cy="44" r="10" fill="#F4D58D" />
        {/* hair tuft */}
        <path d="M52 38 Q60 30 68 38" fill="#7A4A1E" stroke="#000" strokeWidth="2" />
        <circle cx="57" cy="44" r="1.2" fill="#000" />
        <circle cx="63" cy="44" r="1.2" fill="#000" />
        <path d="M57 48 Q60 51 63 48" stroke="#000" strokeWidth="1.5" fill="none" />
      </g>
    </svg>
  </Wrap>
);

export const StickerShoe = ({ size, rotate, className }) => (
  <Wrap size={size} rotate={rotate} className={className} title="running shoe sticker">
    <svg viewBox="0 0 110 100" className="w-full h-full drop-shadow-[3px_3px_0_#000]">
      <g stroke="#000" strokeWidth="3" strokeLinejoin="round">
        <path d="M10 70 Q14 50 30 48 L60 44 Q80 42 96 56 L100 70 Q98 78 88 78 L18 78 Q10 78 10 70 Z" fill="#F87171" />
        <path d="M30 48 Q38 38 50 40" fill="none" stroke="#fff" strokeWidth="3" />
        <path d="M40 46 L48 56" stroke="#fff" strokeWidth="3" />
        <path d="M55 44 L62 56" stroke="#fff" strokeWidth="3" />
        <path d="M70 44 L78 58" stroke="#fff" strokeWidth="3" />
        <rect x="10" y="72" width="90" height="8" fill="#fff" />
        <line x1="10" y1="80" x2="100" y2="80" stroke="#000" strokeWidth="3" />
      </g>
    </svg>
  </Wrap>
);

export const StickerCassette = ({ size, rotate, className }) => (
  <Wrap size={size} rotate={rotate} className={className} title="cassette tape sticker">
    <svg viewBox="0 0 110 80" className="w-full h-full drop-shadow-[3px_3px_0_#000]">
      <g stroke="#000" strokeWidth="3" strokeLinejoin="round">
        <rect x="6" y="8" width="98" height="62" rx="6" fill="#B57FA0" />
        <rect x="14" y="18" width="82" height="28" fill="#FFF4D6" />
        <circle cx="34" cy="32" r="7" fill="#000" />
        <circle cx="76" cy="32" r="7" fill="#000" />
        <circle cx="34" cy="32" r="2" fill="#fff" />
        <circle cx="76" cy="32" r="2" fill="#fff" />
        <text x="55" y="60" textAnchor="middle" fontFamily="VT323, monospace" fontSize="14" fill="#000">MIXTAPE 90</text>
      </g>
    </svg>
  </Wrap>
);

export const StickerSmile = ({ size, rotate, className }) => (
  <Wrap size={size} rotate={rotate} className={className} title="smiley sticker">
    <svg viewBox="0 0 100 100" className="w-full h-full drop-shadow-[3px_3px_0_#000]">
      <circle cx="50" cy="50" r="42" fill="#F4D58D" stroke="#000" strokeWidth="4" />
      <circle cx="38" cy="42" r="5" fill="#000" />
      <circle cx="62" cy="42" r="5" fill="#000" />
      <path d="M32 58 Q50 78 68 58" fill="none" stroke="#000" strokeWidth="5" strokeLinecap="round" />
    </svg>
  </Wrap>
);

export const StickerHeart = ({ size, rotate, className }) => (
  <Wrap size={size} rotate={rotate} className={className} title="heart sticker">
    <svg viewBox="0 0 100 100" className="w-full h-full drop-shadow-[3px_3px_0_#000]">
      <path d="M50 86 C20 64 8 46 22 28 C34 14 50 22 50 36 C50 22 66 14 78 28 C92 46 80 64 50 86 Z"
        fill="#F87171" stroke="#000" strokeWidth="4" strokeLinejoin="round" />
      <path d="M30 30 Q35 24 42 26" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
    </svg>
  </Wrap>
);

export const StickerStar = ({ size, rotate, className }) => (
  <Wrap size={size} rotate={rotate} className={className} title="star sticker">
    <svg viewBox="0 0 100 100" className="w-full h-full drop-shadow-[3px_3px_0_#000]">
      <path d="M50 6 L60 38 L94 38 L66 58 L76 90 L50 70 L24 90 L34 58 L6 38 L40 38 Z"
        fill="#8ECAE6" stroke="#000" strokeWidth="4" strokeLinejoin="round" />
    </svg>
  </Wrap>
);

export const StickerBolt = ({ size, rotate, className }) => (
  <Wrap size={size} rotate={rotate} className={className} title="lightning sticker">
    <svg viewBox="0 0 80 100" className="w-full h-full drop-shadow-[3px_3px_0_#000]">
      <path d="M44 4 L8 56 L34 56 L26 96 L72 40 L46 40 L56 4 Z"
        fill="#F4D58D" stroke="#000" strokeWidth="4" strokeLinejoin="round" />
    </svg>
  </Wrap>
);

export const StickerPeace = ({ size, rotate, className }) => (
  <Wrap size={size} rotate={rotate} className={className} title="peace sign sticker">
    <svg viewBox="0 0 100 100" className="w-full h-full drop-shadow-[3px_3px_0_#000]">
      <circle cx="50" cy="50" r="42" fill="#B57FA0" stroke="#000" strokeWidth="4" />
      <line x1="50" y1="8" x2="50" y2="92" stroke="#000" strokeWidth="5" />
      <line x1="50" y1="50" x2="20" y2="80" stroke="#000" strokeWidth="5" />
      <line x1="50" y1="50" x2="80" y2="80" stroke="#000" strokeWidth="5" />
    </svg>
  </Wrap>
);

export const StickerWave = ({ size, rotate, className }) => (
  <Wrap size={size} rotate={rotate} className={className} title="wave sticker">
    <svg viewBox="0 0 120 80" className="w-full h-full drop-shadow-[3px_3px_0_#000]">
      <g stroke="#000" strokeWidth="3" strokeLinejoin="round">
        <path d="M4 50 Q24 10 50 34 Q76 60 116 28 L116 70 Q60 80 4 70 Z" fill="#5BA8C7" />
        <path d="M14 50 Q28 26 48 40" fill="none" stroke="#fff" strokeWidth="3" />
        <path d="M58 44 Q78 60 100 38" fill="none" stroke="#fff" strokeWidth="3" />
      </g>
    </svg>
  </Wrap>
);

export const StickerFlower = ({ size, rotate, className }) => (
  <Wrap size={size} rotate={rotate} className={className} title="flower sticker">
    <svg viewBox="0 0 100 100" className="w-full h-full drop-shadow-[3px_3px_0_#000]">
      <g stroke="#000" strokeWidth="3" strokeLinejoin="round">
        {[0, 60, 120, 180, 240, 300].map((deg, i) => (
          <ellipse key={i} cx="50" cy="22" rx="14" ry="22" fill="#F87171"
            transform={`rotate(${deg} 50 50)`} />
        ))}
        <circle cx="50" cy="50" r="12" fill="#F4D58D" />
      </g>
    </svg>
  </Wrap>
);

export const StickerSkate = ({ size, rotate, className }) => (
  <Wrap size={size} rotate={rotate} className={className} title="skateboard sticker">
    <svg viewBox="0 0 120 60" className="w-full h-full drop-shadow-[3px_3px_0_#000]">
      <g stroke="#000" strokeWidth="3" strokeLinejoin="round">
        <rect x="6" y="14" width="108" height="20" rx="10" fill="#F4A261" />
        <circle cx="22" cy="44" r="8" fill="#000" />
        <circle cx="98" cy="44" r="8" fill="#000" />
        <circle cx="22" cy="44" r="3" fill="#fff" />
        <circle cx="98" cy="44" r="3" fill="#fff" />
        <path d="M16 22 L104 22" stroke="#fff" strokeWidth="2" strokeDasharray="6 4" />
      </g>
    </svg>
  </Wrap>
);

export const StickerVan = ({ size, rotate, className }) => (
  <Wrap size={size} rotate={rotate} className={className} title="retro van sticker">
    <svg viewBox="0 0 140 80" className="w-full h-full drop-shadow-[3px_3px_0_#000]">
      <g stroke="#000" strokeWidth="3" strokeLinejoin="round">
        <path d="M6 56 L6 36 Q6 22 22 22 L86 22 L108 36 L132 36 Q136 36 136 42 L136 58 Q136 62 132 62 L8 62 Q4 62 4 58 Z"
          fill="#F4D58D" />
        <rect x="14" y="28" width="22" height="14" fill="#8ECAE6" />
        <rect x="40" y="28" width="22" height="14" fill="#8ECAE6" />
        <rect x="66" y="28" width="22" height="14" fill="#8ECAE6" />
        <path d="M6 50 L136 50" stroke="#F87171" strokeWidth="4" />
        <circle cx="32" cy="64" r="9" fill="#000" />
        <circle cx="112" cy="64" r="9" fill="#000" />
        <circle cx="32" cy="64" r="3" fill="#fff" />
        <circle cx="112" cy="64" r="3" fill="#fff" />
      </g>
    </svg>
  </Wrap>
);

export const StickerMoon = ({ size, rotate, className }) => (
  <Wrap size={size} rotate={rotate} className={className} title="crescent moon sticker">
    <svg viewBox="0 0 100 100" className="w-full h-full drop-shadow-[3px_3px_0_#000]">
      <g stroke="#000" strokeWidth="3" strokeLinejoin="round">
        <path d="M70 14 A40 40 0 1 0 70 86 A30 30 0 1 1 70 14 Z" fill="#F5D547" />
        <circle cx="58" cy="46" r="3" fill="#000" />
        <path d="M52 58 Q60 64 66 58" fill="none" stroke="#000" strokeWidth="3" strokeLinecap="round" />
        <circle cx="20" cy="22" r="2" fill="#FFF" />
        <circle cx="14" cy="60" r="2" fill="#FFF" />
        <circle cx="92" cy="80" r="2" fill="#FFF" />
      </g>
    </svg>
  </Wrap>
);

export const StickerSunflower = ({ size, rotate, className }) => (
  <Wrap size={size} rotate={rotate} className={className} title="sunflower sticker">
    <svg viewBox="0 0 100 110" className="w-full h-full drop-shadow-[3px_3px_0_#000]">
      <g stroke="#000" strokeWidth="3" strokeLinejoin="round">
        <path d="M50 60 L50 105" stroke="#2A7F2A" strokeWidth="5" />
        <path d="M50 86 Q34 78 30 90 Q44 92 50 90" fill="#7FB069" />
        <path d="M50 92 Q68 86 74 96 Q60 100 50 96" fill="#7FB069" />
        {[...Array(12)].map((_, i) => {
          const a = (i * 30 * Math.PI) / 180;
          const cx = 50 + Math.cos(a) * 22;
          const cy = 40 + Math.sin(a) * 22;
          return <ellipse key={i} cx={cx} cy={cy} rx="10" ry="16" fill="#F4D58D"
            transform={`rotate(${i * 30} ${cx} ${cy})`} />;
        })}
        <circle cx="50" cy="40" r="14" fill="#7A4A1E" />
        <circle cx="50" cy="40" r="14" fill="none" stroke="#000" strokeWidth="3" />
        <circle cx="46" cy="36" r="2" fill="#000" />
        <circle cx="54" cy="36" r="2" fill="#000" />
        <path d="M44 44 Q50 50 56 44" fill="none" stroke="#000" strokeWidth="2.5" strokeLinecap="round" />
      </g>
    </svg>
  </Wrap>
);

export const StickerCampfire = ({ size, rotate, className }) => (
  <Wrap size={size} rotate={rotate} className={className} title="campfire sticker">
    <svg viewBox="0 0 100 100" className="w-full h-full drop-shadow-[3px_3px_0_#000]">
      <g stroke="#000" strokeWidth="3" strokeLinejoin="round">
        {/* outer flame */}
        <path d="M50 8 C30 30 28 44 36 60 C40 70 60 70 64 60 C72 44 70 30 50 8 Z" fill="#F4A261" />
        {/* inner flame */}
        <path d="M50 22 C40 38 38 48 44 58 C48 64 56 64 56 58 C62 48 60 38 50 22 Z" fill="#F4D58D" />
        {/* logs */}
        <rect x="14" y="74" width="72" height="8" rx="4" fill="#7A4A1E" transform="rotate(-8 50 78)" />
        <rect x="14" y="84" width="72" height="8" rx="4" fill="#5A3A14" transform="rotate(6 50 88)" />
        {/* sparks */}
        <circle cx="22" cy="34" r="2" fill="#F87171" />
        <circle cx="80" cy="42" r="2" fill="#F87171" />
        <circle cx="74" cy="22" r="2" fill="#F4D58D" />
      </g>
    </svg>
  </Wrap>
);

export const StickerTent = ({ size, rotate, className }) => (
  <Wrap size={size} rotate={rotate} className={className} title="tent sticker">
    <svg viewBox="0 0 120 90" className="w-full h-full drop-shadow-[3px_3px_0_#000]">
      <g stroke="#000" strokeWidth="3" strokeLinejoin="round">
        <path d="M10 78 L58 8 L70 8 L118 78 Z" fill="#F4A261" />
        <path d="M58 8 L46 78 L72 78 L70 8 Z" fill="#F4D58D" />
        <path d="M58 8 L60 78" stroke="#000" strokeWidth="3" />
        <line x1="10" y1="78" x2="118" y2="78" stroke="#000" strokeWidth="3" />
        {/* zigzag */}
        <path d="M16 64 L24 60 L20 56 L28 52" fill="none" stroke="#F87171" strokeWidth="2.5" />
        <path d="M84 62 L92 58 L88 54 L96 50" fill="none" stroke="#8ECAE6" strokeWidth="2.5" />
      </g>
    </svg>
  </Wrap>
);

export const StickerTree = ({ size, rotate, className }) => (
  <Wrap size={size} rotate={rotate} className={className} title="pine tree sticker">
    <svg viewBox="0 0 80 110" className="w-full h-full drop-shadow-[3px_3px_0_#000]">
      <g stroke="#000" strokeWidth="3" strokeLinejoin="round">
        <rect x="32" y="84" width="16" height="20" fill="#7A4A1E" />
        <path d="M40 6 L12 38 L26 38 L8 64 L26 64 L4 92 L76 92 L54 64 L72 64 L54 38 L68 38 Z"
          fill="#2A7F4A" />
        <circle cx="28" cy="50" r="3" fill="#F87171" />
        <circle cx="52" cy="70" r="3" fill="#F4D58D" />
        <circle cx="40" cy="36" r="3" fill="#8ECAE6" />
      </g>
    </svg>
  </Wrap>
);

/* ====== TRIPPY / WAVY STICKERS (80s/90s psychedelic) ====== */

export const StickerSwirl = ({ size, rotate, className }) => (
  <Wrap size={size} rotate={rotate} className={className} title="psychedelic swirl sticker">
    <svg viewBox="0 0 100 100" className="w-full h-full drop-shadow-[3px_3px_0_#000]">
      <defs>
        <radialGradient id="swirlGrad" cx="50%" cy="50%">
          <stop offset="0%" stopColor="#F4D58D" />
          <stop offset="35%" stopColor="#F4A261" />
          <stop offset="65%" stopColor="#F87171" />
          <stop offset="100%" stopColor="#B57FA0" />
        </radialGradient>
      </defs>
      <circle cx="50" cy="50" r="44" fill="url(#swirlGrad)" stroke="#000" strokeWidth="3" />
      <g fill="none" stroke="#000" strokeWidth="3" strokeLinecap="round">
        <path d="M50 50 C70 50 70 30 50 30 C30 30 30 65 50 65 C75 65 75 22 50 22 C20 22 20 75 50 75 C82 75 82 14 50 14" />
      </g>
    </svg>
  </Wrap>
);

export const StickerYinWave = ({ size, rotate, className }) => (
  <Wrap size={size} rotate={rotate} className={className} title="yin yang sticker">
    <svg viewBox="0 0 100 100" className="w-full h-full drop-shadow-[3px_3px_0_#000]">
      <g stroke="#000" strokeWidth="3" strokeLinejoin="round">
        <circle cx="50" cy="50" r="44" fill="#8ECAE6" />
        <path d="M50 6 A22 22 0 0 1 50 50 A22 22 0 0 0 50 94 A44 44 0 0 1 50 6 Z" fill="#F87171" />
        <circle cx="50" cy="28" r="5" fill="#8ECAE6" stroke="#000" strokeWidth="2" />
        <circle cx="50" cy="72" r="5" fill="#F87171" stroke="#000" strokeWidth="2" />
      </g>
    </svg>
  </Wrap>
);

export const StickerHibiscus = ({ size, rotate, className }) => (
  <Wrap size={size} rotate={rotate} className={className} title="hibiscus flower sticker">
    <svg viewBox="0 0 100 100" className="w-full h-full drop-shadow-[3px_3px_0_#000]">
      <g stroke="#000" strokeWidth="3" strokeLinejoin="round">
        {[0, 72, 144, 216, 288].map((deg, i) => (
          <path
            key={i}
            d="M50 50 Q34 30 50 8 Q66 30 50 50 Z"
            fill="#F4A261"
            transform={`rotate(${deg} 50 50)`}
          />
        ))}
        <circle cx="50" cy="50" r="9" fill="#F4D58D" />
        {/* stamen lines */}
        <line x1="50" y1="50" x2="50" y2="38" stroke="#F87171" strokeWidth="2.5" strokeLinecap="round" />
        <line x1="50" y1="50" x2="58" y2="42" stroke="#F87171" strokeWidth="2.5" strokeLinecap="round" />
        <line x1="50" y1="50" x2="42" y2="42" stroke="#F87171" strokeWidth="2.5" strokeLinecap="round" />
      </g>
    </svg>
  </Wrap>
);

export const StickerMeltSmile = ({ size, rotate, className }) => (
  <Wrap size={size} rotate={rotate} className={className} title="melting smiley sticker">
    <svg viewBox="0 0 100 110" className="w-full h-full drop-shadow-[3px_3px_0_#000]">
      <g stroke="#000" strokeWidth="3" strokeLinejoin="round">
        <path d="M50 4 A42 42 0 0 1 92 46 L92 76 Q88 92 78 86 Q70 100 60 86 Q50 100 40 86 Q30 100 22 86 Q12 92 8 76 L8 46 A42 42 0 0 1 50 4 Z"
          fill="#F4D58D" />
        <ellipse cx="36" cy="40" rx="5" ry="7" fill="#000" />
        <ellipse cx="64" cy="40" rx="5" ry="7" fill="#000" />
        <path d="M30 60 Q50 80 70 60" fill="none" stroke="#000" strokeWidth="5" strokeLinecap="round" />
        <path d="M32 60 Q34 70 32 78" stroke="#000" strokeWidth="3" fill="none" strokeLinecap="round" />
        <path d="M68 60 Q66 72 70 80" stroke="#000" strokeWidth="3" fill="none" strokeLinecap="round" />
      </g>
    </svg>
  </Wrap>
);

export const StickerCheckerWave = ({ size, rotate, className }) => (
  <Wrap size={size} rotate={rotate} className={className} title="checker wave sticker">
    <svg viewBox="0 0 140 60" className="w-full h-full drop-shadow-[3px_3px_0_#000]">
      <defs>
        <pattern id="cw" width="14" height="14" patternUnits="userSpaceOnUse">
          <rect width="14" height="14" fill="#fff" />
          <rect width="7" height="7" fill="#000" />
          <rect x="7" y="7" width="7" height="7" fill="#000" />
        </pattern>
      </defs>
      <path d="M4 30 Q24 6 50 30 T96 30 T136 30 L136 50 Q116 30 96 50 T50 50 T4 50 Z"
        fill="url(#cw)" stroke="#000" strokeWidth="3" strokeLinejoin="round" />
    </svg>
  </Wrap>
);

export const StickerEye = ({ size, rotate, className }) => (
  <Wrap size={size} rotate={rotate} className={className} title="trippy eye sticker">
    <svg viewBox="0 0 110 80" className="w-full h-full drop-shadow-[3px_3px_0_#000]">
      <g stroke="#000" strokeWidth="3" strokeLinejoin="round">
        <path d="M6 40 Q55 -8 104 40 Q55 88 6 40 Z" fill="#fff" />
        <circle cx="55" cy="40" r="18" fill="#8ECAE6" />
        <circle cx="55" cy="40" r="10" fill="#F87171" />
        <circle cx="55" cy="40" r="5" fill="#000" />
        <circle cx="51" cy="36" r="2" fill="#fff" />
        {/* eyelashes */}
        <path d="M22 18 L18 8" /><path d="M40 8 L38 -2" /><path d="M70 8 L72 -2" /><path d="M88 18 L92 8" />
      </g>
    </svg>
  </Wrap>
);

/* Scattered backdrop of stickers, absolutely positioned in a relative parent. */
export const StickerScatter = ({ items }) => (
  <>
    {items.map((it, idx) => {
      const Comp = STICKER_MAP[it.kind] || StickerStar;
      return (
        <div
          key={idx}
          className={`absolute pointer-events-auto float-slow hover-wobble ${it.className || ""}`}
          style={{
            top: it.top,
            left: it.left,
            right: it.right,
            bottom: it.bottom,
            zIndex: it.z || 5,
            "--rot": `${it.rotate || 0}deg`,
          }}
          data-testid={`sticker-${it.kind}-${idx}`}
        >
          <Comp size={it.size || 80} rotate={it.rotate || 0} />
        </div>
      );
    })}
  </>
);

export const STICKER_MAP = {
  sun: StickerSun,
  palm: StickerPalm,
  surf: StickerSurf,
  shoe: StickerShoe,
  cassette: StickerCassette,
  smile: StickerSmile,
  heart: StickerHeart,
  star: StickerStar,
  bolt: StickerBolt,
  peace: StickerPeace,
  wave: StickerWave,
  flower: StickerFlower,
  skate: StickerSkate,
  van: StickerVan,
  moon: StickerMoon,
  sunflower: StickerSunflower,
  campfire: StickerCampfire,
  tent: StickerTent,
  tree: StickerTree,
  swirl: StickerSwirl,
  yinwave: StickerYinWave,
  hibiscus: StickerHibiscus,
  meltsmile: StickerMeltSmile,
  checkerwave: StickerCheckerWave,
  eye: StickerEye,
};
